// Cached elements
const $el = {
	element: $('.js-append'),
};

// Module events
export default function init() {
    $el.element.appendAround();
};